import axios from 'axios'
import { clone, deleteKeyNullValues } from "@/util/libUtil.js"

import tariffManagement from './tariffManagement.js'
import SVAManagement from './SVAManagement.js'
import promotionManagement from './promotionManagement.js'
import additionalManagement from './additionalManagement.js'
import procedureManagement from './procedureManagement.js'
import dboriginManagement from './dboriginManagement.js'
import insuranceManagement from './insuranceManagement.js'
import objectiveTypesManagement from './objectiveTypesManagement.js'

import defaultUpfrontForm from '@/util/management/defaultUpfrontForm.js';
import defaultPriceHistoryForm from '@/util/management/defaultPriceHistoryForm.js';
import defaultManagementFilters from '@/util/management/defaultManagementFilters.js';


const state = () => ({
    confirmDeletion: false,   // Booleano para saber si el diálogo de borrado está abierto
    itemsPerPage: 16,         // Número de items por página
    managementFilters: {
        isOpen: false,
        form: clone(defaultManagementFilters)
    },
    baseForm: {
        type: '',
        item_id: null,
        formType: 'edit',
        isOpenBaseDialog: false,
        upfrontHistoryForm: clone(defaultUpfrontForm),
        priceHistoryForm: clone(defaultPriceHistoryForm),
    },
    deleteData: {
        item: null,
        module: ''
    },
    tipoObjetivo: [],
    loadingItems: false,
    paths: {
        optionsPath: '/api/utils/opciones/',
        tipoObjetivoPath: '/api/servicios/tipoobjetivo/',
        priceHistoryPath: '/api/servicios/pricehistory/',
        upfrontHistoryPath: '/api/servicios/upfronts/',
    }
})

const mutations = {
    itemsPerPage: (state, val) => {
        state.itemsPerPage = val
    },
    isOpenManagementFilterForm: (state, val) => {
        state.managementFilters.isOpen = val
    },
    managementFilterForm: (state, val) => {
        state.managementFilters.form = clone(val)
    },
    baseForm: (state, val) => {
        state.baseForm = clone(val)
    },
    upfrontHistoryForm: (state, val) => {
        state.baseForm.upfrontHistoryForm = clone(val)
    },
    priceHistoryForm: (state, val) => {
        state.baseForm.priceHistoryForm = clone(val)
    },
    isOpenBaseDialog: (state, val) => {
        state.baseForm.isOpenBaseDialog = val
    },
    confirmDeletion: (state, { val, deleteData }) => {
        state.confirmDeletion = val
        state.deleteData = clone(deleteData)
    },
    removingTable: (state, val) => {
        state.removingTable = val
    },
    removingElementId: (state, val) => {
        state.removingElementId = val
    },
    tipoObjetivo: (state, val) => {
        state.tipoObjetivo = clone(val)
    },
    loadingItems: (state, val) => {
        state.loadingItems = val
    },
}

const actions = {
    async editPriceHistory({ state, getters, dispatch }, id) {
        try {
            await axios.put(getters.getEndpointFromPath(state.paths.priceHistoryPath) + id + '/', deleteKeyNullValues(state.baseForm.priceHistoryForm)).then(
                () =>dispatch('updateView', {'type': 'success', 'message': 'Precio Editado Correctamente'})
            )
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })
        } catch(error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                statusType: 'error',
                message: 'Error al editar precio',
            }, { root: true })
        }
    },
    async editUpfrontHistory({ state, getters, dispatch }, id) {
        try {
            await axios.put(getters.getEndpointFromPath(state.paths.upfrontHistoryPath) + id + '/', deleteKeyNullValues(state.baseForm.upfrontHistoryForm)).then(
                () =>dispatch('updateView', {'type': 'success', 'message': 'Precio Editado Correctamente'})
            )
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })
        } catch(error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                statusType: 'error',
                message: 'Error al editar upfront',
            }, { root: true })
        }
    },
    async addPriceHistory({ state, getters, dispatch }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.priceHistoryPath), deleteKeyNullValues(state.baseForm.priceHistoryForm)).then(
                () =>dispatch('updateView', {'type': 'success', 'message': 'Precio Añadido Correctamente'})
            )
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })
        } catch(error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                statusType: 'error',
                message: 'Error al añadir precio',
            }, { root: true })
        }
    },
    async addUpfrontHistory({ state, getters, dispatch }) {
        try {
            await axios.post(getters.getEndpointFromPath(state.paths.upfrontHistoryPath), deleteKeyNullValues(state.baseForm.upfrontHistoryForm)).then(
                () =>dispatch('updateView', {'type': 'success', 'message': 'Upfront Añadido Correctamente'})
            )
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })
        } catch(error) {
            dispatch('util/showStatusSnackBar', {
                error: error,
                statusType: 'error',
                message: 'Error al añadir upfront',
            }, { root: true })
        }
    },
    async deleteHistoryPrice({ state, dispatch, getters, rootState }, id) {
        // try {
            await axios.delete(getters.getEndpointFromPath(state.paths.priceHistoryPath) + id + '/')
            dispatch('updateView', {'type': 'success', 'message': 'Precio Borrado Correctamente'})
        // } catch {
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'error',
        //         message: 'No se pudo eliminar la entrada'
        //     }, { root: true })
        // }
    },
    async deleteHistoryUpfront({ state, dispatch, getters, rootState }, id) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.upfrontHistoryPath) + id + '/')
            dispatch('updateView', {'type': 'success', 'message': 'Upfront Borrado Correctamente'})
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    updateView({ state, dispatch, rootState }, {type, message}){
        let params = {
            search: rootState.util.navBarSearchField,
            page: rootState.ManagementBase.tariffManagement.page,
            itemsPerPage: 15,
        };

        params = { ...params, ...state.managementFilters.form }

        if(state.baseForm.type == 'TARIFF')
            dispatch('ManagementBase/tariffManagement/getTariffs', params, { root: true })
        else if(state.baseForm.type == 'ADITIONAL')
            dispatch('ManagementBase/additionalManagement/getAdditionals', {}, { root: true })
        else if(state.baseForm.type == 'SVA')
            dispatch('ManagementBase/SVAManagement/getSVA', {}, { root: true })
        else if(state.baseForm.type == 'INSURANCE')
            dispatch('ManagementBase/insuranceManagement/getInsurances', {}, { root: true })
        else if(state.baseForm.type == 'ADMINISTRATION')
            dispatch('ManagementBase/procedureManagement/getProcedures', {}, { root: true })

        dispatch('util/showStatusSnackBar', {
            statusType: type,
            message: message
        }, { root: true })
    },
    deleteObject({ state, dispatch }) {
        dispatch(state.deleteData.module + '/delete', state.deleteData.item, { root: true })
        // try {
        //     let resp = await axios.delete(getters.getEndpointFromPath(state.deleteData.path)+state.deleteData.item.id + '/')
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'success',
        //         message: 'Entrada borrada'
        //     }, {root: true})
        // } catch {
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'error',
        //         message: 'No se pudo eliminar la entrada'
        //     }, {root: true})
        // }
    },
    async fetchTipoObjetivo({ getters, state, commit }) {
        let response = await axios.get(getters.getEndpointFromPath(state.paths.tipoObjetivoPath))
        try {
            commit("tipoObjetivo", response.data)
        }
        catch {

        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
    itemsPerPage: state => state.itemsPerPage,
}

const modules = {
    tariffManagement,
    SVAManagement,
    promotionManagement,
    additionalManagement,
    procedureManagement,
    dboriginManagement,
    insuranceManagement,
    objectiveTypesManagement
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
    modules
}
